/**
 * Full-width page banner with a background image, dark overlay, and title.
 * Props: image (string), title (string), subtitle (string, optional)
 */
const PageBanner = ({ image, title, subtitle, position = 'bg-center' }) => {
    return (
        <div
            className={`relative h-72 md:h-[420px] w-full bg-cover ${position} flex items-end`}
            style={{ backgroundImage: `url(${image})` }}
        >
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-stone-950/30 to-transparent" />

            <div className="relative z-10 pb-10 px-8 md:px-16 lg:px-24 animate-fade-up">
                {subtitle && (
                    <p className="font-sans text-xs tracking-widest uppercase text-jade-300 mb-3">
                        {subtitle}
                    </p>
                )}
                <h1 className="font-serif text-5xl md:text-7xl font-light text-white tracking-wide leading-none">
                    {title}
                </h1>
                <div className="w-12 h-px bg-jade-400 mt-5" />
            </div>
        </div>
    );
};

export default PageBanner;
